import React, { useState, useEffect, useMemo } from 'react'
import { Form, Button, InputGroup } from "react-bootstrap"
import users from "../img/users.svg";
import ConfirmatoryModal from "../Components/ConfirmatoryModal";
import * as formik from 'formik';
import * as yup from 'yup';
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { deleteUser, saveUser, handleChange, handleSubmit, getModalData } from "../Functions/myfunctions";
import { useNavigate } from 'react-router-dom';


function ModificationUser() {
    const { Formik } = formik;
    const [errorMessage, setErrorMessage] = useState("");

    const [loading, setLoading] = useState(false);
    const [modifiedData, setModifiedData] = useState([]);
    const [modalShow, setModalShow] = React.useState(false);
    const [actionName, setActionName] = useState({ name: '', action: '', values: '' });
    const [urlLink, setUrlLink] = useState();
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        Name: "",
        UserName: "",
        Role: "",
        Active: "",
    })


    const location = useLocation();
    const { token } = useParams();

    const loadData = async () => {
        setLoading(true);

        axios.post(process.env.REACT_APP_BASE_URL + "/api/users/edit/" + token + "/?code=" + process.env.REACT_APP_API_KEY, {
            "sessionToken": sessionStorage.getItem("sessionToken")
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            console.log(res);
            console.log(res.data);
            setModifiedData(res.data);
        }).catch((error) => {
            if (error.response.data === "Access denied!") {
                sessionStorage.clear();
                window.location = "/";
            }

            if (error.response.data === "User not found!") {
                setErrorMessage("Hiba történt! A felhasználó nem található!");
            }
        });
        setLoading(false);
    }

    useEffect(() => {
        loadData();
    }, [])



    const ModificationUserSchema = yup.object().shape({
        Name: yup.string()
            .required('A név kitöltése kötelező'),
        UserName: yup.string()
            .required('A felhasználónév kitöltése kötelező'),
        Password: yup.string()
            .matches(/[0-9]/, "A jelszónak tartalmaznia kell számot.")
            .matches(/[a-z]/, "A jelszónak tartalmaznia kell kis betűt")
            .matches(/[A-Z]/, "A jelszónak tartalmaznia kell nagy betűt")
            .min(12, 'A jelszónak minimum 12 hosszúnak kell lennie!'),
        Password2: yup.string()
            .oneOf([yup.ref('Password'), null], "A jelszónak és a megerősítő jelszónak meg kell egyeznie"),
        Role: yup.string()
            .required('Szerepkör választása kötelező'),
        Active: yup.string()
            .required('Státusz választása kötelező'),
    });

    const save = (values, actions) => {
        getModalData({ name: 'Kívánja a módosítást végrehajtani?', action: 'save', values: values }, "", modalShow, setActionName, setUrlLink, setModalShow);
    }


    const confirmationfunction = (event) => {
        event.preventDefault();
        const dataCopy = { ...actionName.values };
        if (dataCopy['Password'] === "") {
            delete dataCopy["Password"];
        }
        delete dataCopy['Password2'];
        dataCopy["sessionToken"] = sessionStorage.getItem("sessionToken");
        dataCopy["RowId"] = token;
        if (actionName.action === "save") {
            saveUser(dataCopy, setErrorMessage);
        }

        if (actionName.action === "delete") {
            deleteUser(token, setErrorMessage, "redirect");
        }
        setModalShow(false);
    }

    const navigate = useNavigate();

    const navigateToUsers = () => {
        // 👇️ navigate to /users
        navigate('/users');
    };

    return (
        <div className="form-page-content" >
            <div className='custom-title'><img src={users} alt="user icon" /><h1>Felhasználó módosítás</h1></div><br />
            <Formik
                initialValues={{
                    Name: modifiedData.Name,
                    UserName: modifiedData.UserName,
                    Role: modifiedData.Role,
                    Active: modifiedData.Active,
                }}
                enableReinitialize={true}
                validationSchema={ModificationUserSchema}
                onSubmit={(values, actions) => {
                    save(values, actions);
                }}
            >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="Name">
                            <Form.Label >
                                Név*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="text" placeholder="Név" name="Name" required value={values.Name} onChange={handleChange} isInvalid={!!errors.Name} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.Name}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="UserName">
                            <Form.Label >
                                Felhasználónév*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="text" placeholder="Felhasználónév" required name="UserName" value={values.UserName} onChange={handleChange} isInvalid={!!errors.UserName} />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.UserName}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Password">
                            <Form.Label >
                                Jelszó*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="password" placeholder="Jelszó" name="Password" value={values.Password} onChange={handleChange} autoComplete='new-password' isInvalid={!!errors.Password} />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.Password}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Password2">
                            <Form.Label >
                                Jelszó újra*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="password" placeholder="Jelszó újra" name="Password2" value={values.Password2} onChange={handleChange} autoComplete='new-password' isInvalid={!!errors.Password2} />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.Password2}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Role">
                            <InputGroup hasValidation>
                                <Form.Label >Szerepkör*</Form.Label>
                                <Form.Select aria-label="select role" value={values.Role} onChange={handleChange} isInvalid={!!errors.Role}>
                                    <option disabled >Szerepkör</option>
                                    <option value="admin">Admin</option>
                                    <option value="user">Általános felhasználó</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.Role}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Active">
                            <InputGroup hasValidation>
                                <Form.Label >Státusz*</Form.Label>
                                <Form.Select aria-label="select active" value={values.Active} onChange={handleChange} isInvalid={!!errors.Active} >
                                    <option disabled>Státusz</option>
                                    <option value="1">Aktív</option>
                                    <option value="0">Inaktív</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.Active}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3 form-buttons">
                            <Button type="submit" className="form-custom-button">Mentés</Button><Button onClick={navigateToUsers} className='form-delete-button'>Mégsem</Button>
                        </Form.Group>
                        {errorMessage !== "" ? <p className="error mb-3">{errorMessage}</p> : ""}
                    </Form>
                )}
            </Formik>
            <ConfirmatoryModal actionname={actionName} urllink={urlLink} confirmationfunction={confirmationfunction}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div >
    )

}

export default ModificationUser;
